module.exports = __webpack_public_path__ + "first-200-paper.jpg?fc633019de20854680bdfcf0cf9738ca";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/first-200-paper.jpg
// module id = 474
// module chunks = 0